import React from "react";
import { ElementGroup } from '@whalecloud/page-builder-core/constant';
import Text from "./components/Text";
import { ReactComponent as PluginSvg } from "@assets/icons/text.svg";
import { getLocale, defaultTarget } from '@utils/util';

export default () => {
  const messages = getLocale();
  return {
    name: 'text',
    group: ElementGroup.BASIC,
    target: defaultTarget,
    title: messages['PAGEBUIDER_SETTINGS_TEXT'],
    toolBarPreview: <PluginSvg />,
    data: {
      text: messages['PAGEBUIDER_SETTINGS_TEXT'],
      componentSettings: {},
      settings: {
      }
    },
    pluginComponent: Text, // 插件渲染组件
  }
}
